module.exports = __webpack_public_path__ + "static/media/homeGif5.6ffc9db7.gif";